import QuoteDetailInfo from "@/pages/order/inquiry/components/quoteDetailInfo.vue";
import QuoteDetailProduct from "@/pages/order/inquiry/components/quoteDetailProduct.vue";
import quoteNotifyInfo from "@/pages/order/inquiry/components/quoteNotifyInfo.vue";
import { getInquiryDetail } from "@/services/order/inquiry";
export default {
  name: "inquiryDetail",
  i18n: require("./i18n-inquiry"),
  components: {
    QuoteDetailInfo: QuoteDetailInfo,
    QuoteDetailProduct: QuoteDetailProduct,
    quoteNotifyInfo: quoteNotifyInfo
  },
  data: function data() {
    return {
      activeKey: "1"
    };
  },
  mounted: function mounted() {},
  methods: {}
};